function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 121.929,
  cy: 160.929,
  r: 99.9295,
  fill: "#40444A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M240.839 140.545C240.515 140.57 240.202 140.641 239.871 140.641C232.993 140.641 227.417 135.065 227.417 128.187C227.417 122.946 230.662 118.48 235.249 116.644C228.484 98.5321 215.582 84.9893 199.406 76.4672C199.392 76.46 199.374 76.46 199.36 76.4565C197.072 81.9896 193.638 86.9285 189.308 90.9352C172.722 82.2102 152.483 82.9966 136.542 93.2552C130.165 88.3163 125.329 81.527 122.743 73.713C122.657 73.5031 122.547 73.3145 122.479 73.0903C117.359 74.6951 112.861 76.275 109.965 77.4848C95.0448 71.425 84.6297 68.8061 75.5062 69.8203C74.2074 69.9626 73.9619 71.6955 75.1397 72.2612C83.4341 76.2537 84.8859 86.8218 88.615 94.7283C77.7835 105.161 76.7232 112.74 74.8123 126.408H67.2332C57.0209 126.408 53 134.688 53 144.9V157.735C53 167.947 57.0209 176.224 67.2332 176.224H71.9088C82.5196 207.089 119.775 223.606 158.859 223.606C206.516 223.606 241.65 196.143 241.65 154.874C241.65 149.903 241.362 145.132 240.839 140.545Z",
  fill: "#848D96"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M109.963 121.07C109.963 125.984 105.982 129.965 101.068 129.965C96.1536 129.965 92.1719 125.984 92.1719 121.07C92.1719 116.156 96.1536 112.174 101.068 112.174C105.982 112.174 109.963 116.156 109.963 121.07Z",
  fill: "#4F5357"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M241.65 154.873C239.686 154.873 238.092 153.279 238.092 151.315C238.092 149.35 239.686 147.756 241.65 147.756C249.5 147.756 255.883 141.373 255.883 133.523C255.883 131.559 257.477 129.965 259.442 129.965C261.406 129.965 263 131.559 263 133.523C263 145.298 253.424 154.873 241.65 154.873Z",
  fill: "#848D96"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M259.442 137.082C257.477 137.082 255.883 135.488 255.883 133.524C255.883 125.674 249.5 119.29 241.65 119.29C239.686 119.29 238.092 117.696 238.092 115.732C238.092 113.768 239.686 112.174 241.65 112.174C253.424 112.174 263 121.749 263 133.524C263 135.491 261.406 137.082 259.442 137.082Z",
  fill: "#848D96"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M239.872 144.198C231.044 144.198 223.859 137.014 223.859 128.186C223.859 119.358 231.044 112.174 239.872 112.174C248.7 112.174 255.884 119.358 255.884 128.186C255.884 137.014 248.7 144.198 239.872 144.198ZM239.872 119.29C234.968 119.29 230.976 123.283 230.976 128.186C230.976 133.089 234.968 137.082 239.872 137.082C244.775 137.082 248.767 133.089 248.767 128.186C248.767 123.283 244.775 119.29 239.872 119.29Z",
  fill: "#848D96"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M252.126 129.816C251.628 129.816 251.123 129.713 250.642 129.492C248.856 128.67 248.073 126.557 248.895 124.77C251.041 120.105 251.069 114.747 248.973 110.064C248.169 108.271 248.973 106.168 250.767 105.363C252.553 104.552 254.663 105.36 255.467 107.157C258.403 113.715 258.36 121.216 255.36 127.745C254.766 129.047 253.471 129.816 252.126 129.816Z",
  fill: "#848D96"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M226.415 196.658C217.825 206.586 205.998 214.129 191.893 218.673L192.946 222.178C193.693 224.673 195.992 226.384 198.596 226.384H220.007C228.258 226.384 234.026 218.225 231.283 210.447L226.415 196.658Z",
  fill: "#292F35"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M84.8975 197.053L79.158 211.407C76.2865 218.58 81.5705 226.384 89.2956 226.384H113.282C114.841 226.384 116.246 225.434 116.826 223.982L119.406 217.527C105.781 213.072 93.7755 206.222 84.8975 197.053Z",
  fill: "#292F35"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M154.051 212.561C140.772 212.561 128.695 209.989 116.643 204.655C114.846 203.861 114.035 201.762 114.832 199.961C115.625 198.164 117.725 197.353 119.525 198.147C133.456 204.317 146.867 206.445 163.033 205.046C164.982 204.84 166.715 206.327 166.883 208.284C167.053 210.245 165.602 211.967 163.645 212.134C160.371 212.419 157.176 212.561 154.051 212.561Z",
  fill: "#292F35"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M202.018 103.868C201.107 103.868 200.196 103.519 199.502 102.826C180.416 83.7424 149.359 83.7424 130.272 102.826C128.881 104.217 126.628 104.217 125.241 102.826C123.849 101.434 123.849 99.1854 125.241 97.7941C147.099 75.9319 182.672 75.9319 204.534 97.7941C205.925 99.1854 205.925 101.434 204.534 102.826C203.84 103.519 202.929 103.868 202.018 103.868Z",
  fill: "#292F35"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M133.744 90.8279C151.165 79.1816 173.696 78.3632 191.858 88.3264C198.437 81.0746 202.479 71.485 202.479 60.9204C202.479 38.3181 184.158 20 161.559 20C138.96 20 120.639 38.3181 120.639 60.9204C120.639 72.7553 125.709 83.3626 133.744 90.8279Z",
  fill: "#4F555C"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M148.326 83.9111C157.667 81.0396 167.602 80.6837 177.106 82.7902C184.002 77.9652 188.521 69.9804 188.521 60.9245C188.521 46.1861 176.576 34.2373 161.834 34.2373C147.095 34.2373 135.146 46.1861 135.146 60.9245C135.146 70.7276 140.448 79.2711 148.326 83.9111Z",
  fill: "#B0BAC4"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 184,
  r: 6,
  stroke: "#848D96",
  strokeWidth: 4
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 244,
  r: 6,
  stroke: "#4F555C",
  strokeWidth: 4
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 220,
  cy: 67,
  r: 6,
  stroke: "#4F555C",
  strokeWidth: 4
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 196,
  r: 4,
  fill: "#292F35"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 196,
  r: 4,
  stroke: "#B0BAC4"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 240,
  r: 4,
  fill: "#292F35"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 240,
  r: 4,
  stroke: "#B0BAC4"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70 240C69.1716 240 68.5 240.672 68.5 241.5V244.5H65.5C64.6716 244.5 64 245.172 64 246C64 246.828 64.6716 247.5 65.5 247.5H68.5V250.5C68.5 251.328 69.1716 252 70 252C70.8284 252 71.5 251.328 71.5 250.5V247.5H74.5C75.3284 247.5 76 246.828 76 246C76 245.172 75.3284 244.5 74.5 244.5H71.5V241.5C71.5 240.672 70.8284 240 70 240Z",
  fill: "#848D96"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59 76C58.1716 76 57.5 76.6716 57.5 77.5V80.5H54.5C53.6716 80.5 53 81.1716 53 82C53 82.8284 53.6716 83.5 54.5 83.5H57.5V86.5C57.5 87.3284 58.1716 88 59 88C59.8284 88 60.5 87.3284 60.5 86.5V83.5H63.5C64.3284 83.5 65 82.8284 65 82C65 81.1716 64.3284 80.5 63.5 80.5H60.5V77.5C60.5 76.6716 59.8284 76 59 76Z",
  fill: "#848D96"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M259 176C258.172 176 257.5 176.672 257.5 177.5V180.5H254.5C253.672 180.5 253 181.172 253 182C253 182.828 253.672 183.5 254.5 183.5H257.5V186.5C257.5 187.328 258.172 188 259 188C259.828 188 260.5 187.328 260.5 186.5V183.5H263.5C264.328 183.5 265 182.828 265 182C265 181.172 264.328 180.5 263.5 180.5H260.5V177.5C260.5 176.672 259.828 176 259 176Z",
  fill: "#4F555C"
});

var SvgExpenseDark = function SvgExpenseDark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExpenseDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "media/ExpenseDark.35598cbe.svg";
export { ForwardRef as ReactComponent };